// https://www.figma.com/file/O0FWE4TJWmIGCksbLUEL0i0y/%E2%9D%96-Web-Component-Library?node-id=11060%3A827

import { TypographyProps } from '@chakra-ui/styled-system';
import { flatten } from 'flat';
import { typography } from './typography';

const { fontSizes, fontWeights, lineHeights } = typography;

const textStylesDefinitions = {
  heading: {
    large: {
      medium: {
        fontWeight: fontWeights.medium,
        fontSize: fontSizes['3xl'],
        lineHeight: lineHeights['2xl'],
      },
    },
    normal: {
      medium: {
        fontWeight: fontWeights.medium,
        fontSize: '2xl',
        lineHeight: lineHeights.xl,
      },
    },
    small: {
      medium: {
        fontWeight: fontWeights.medium,
        fontSize: 'xl',
        lineHeight: lineHeights.lg,
      },
      regular: {
        fontWeight: fontWeights.regular,
        fontSize: 'xl',
        lineHeight: lineHeights.lg,
      },
      light: {
        fontWeight: fontWeights.light,
        fontSize: 'xl',
        lineHeight: lineHeights.lg,
      },
    },
  },
  body: {
    large: {
      bold: {
        fontWeight: fontWeights.bold,
        fontSize: 'lg',
        lineHeight: lineHeights.md,
      },
      medium: {
        fontWeight: fontWeights.medium,
        fontSize: 'md',
        lineHeight: lineHeights.sm,
      },
      regular: {
        fontWeights: fontWeights.regular,
        fontSize: 'sm',
        lineHeight: lineHeights.sm,
      },
      light: {
        fontWeight: fontWeights.light,
        fontSize: 'md',
        lineHeight: lineHeights.sm,
      },
    },
    normal: {
      bold: {
        fontWeight: fontWeights.bold,
        fontSize: 'sm',
        lineHeight: lineHeights.sm,
      },
      medium: {
        fontWeight: fontWeights.medium,
        fontSize: 'sm',
        lineHeight: lineHeights.sm,
      },
      regular: {
        fontWeight: fontWeights.regular,
        fontSize: 'sm',
        lineHeight: lineHeights.sm,
      },
      light: {
        fontWeight: fontWeights.light,
        fontSize: 'sm',
        lineHeight: lineHeights.sm,
      },
    },
    small: {
      medium: {
        fontWeight: fontWeights.medium,
        fontSize: 'xs',
        lineHeight: lineHeights.xs,
      },
      regular: {
        fontWeight: fontWeights.regular,
        fontSize: 'xs',
        lineHeight: lineHeights.xs,
      },
      light: {
        fontWeight: fontWeights.light,
        fontSize: 'xs',
        lineHeight: lineHeights.xs,
      },
    },
  },
  textlink: {
    large: {
      medium: {
        fontWeight: fontWeights.medium,
        fontSize: 'md',
        lineHeight: lineHeights.sm,
      },
    },
    normal: {
      medium: {
        fontWeight: fontWeights.medium,
        fontSize: 'sm',
        lineHeight: lineHeights.sm,
      },
    },
    small: {
      medium: {
        fontWeight: fontWeights.medium,
        fontSize: 'xs',
        lineHeight: lineHeights.xs,
      },
    },
    xsmall: {
      medium: {
        fontWeight: fontWeights.medium,
        fontSize: fontSizes['2xs'],
        lineHeight: lineHeights.xs,
      },
    },
  },
  footnote: {
    xsmall: {
      medium: {
        fontWeight: fontWeights.medium,
        fontSize: fontSizes['2xs'],
        lineHeight: lineHeights.xs,
      },
      regular: {
        fontWeight: fontWeights.regular,
        fontSize: fontSizes['2xs'],
        lineHeight: lineHeights.xs,
      },
      light: {
        fontWeight: fontWeights.light,
        fontSize: fontSizes['2xs'],
        lineHeight: lineHeights.xs,
      },
    },
  },
} as const;

export type TextStyle =
  | 'body-large-bold'
  | 'body-large-medium'
  | 'body-large-regular'
  | 'body-large-light'
  // body-normal
  | 'body-normal-bold'
  | 'body-normal-medium'
  | 'body-normal-regular'
  | 'body-normal-light'
  // body-small
  | 'body-small-medium'
  | 'body-small-regular'
  | 'body-small-light'
  // heading-large
  | 'heading-large-medium'
  // heading-normal
  | 'heading-normal-medium'
  // heading-small
  | 'heading-small-medium'
  | 'heading-small-regular'
  | 'heading-small-light'
  // footnote-xsmall
  | 'footnote-xsmall-medium'
  | 'footnote-xsmall-regular'
  | 'footnote-xsmall-light'
  // textlink
  | 'textlink-large-medium'
  | 'textlink-normal-medium'
  | 'textlink-small-medium'
  | 'textlink-xsmall-medium';

export const textStyles = flatten(textStylesDefinitions, {
  delimiter: '-',
  maxDepth: 3,
}) as Record<TextStyle, TypographyProps>;
